/**
 * Enriquece e filtra relatórios para o card MegaDash na home.
 * Mantém as mesmas regras que historicamente viviam em loadHomeData.
 *
 * @param {Array<object>|undefined|null} reportsData - `data` de `/report/list`
 * @param {object} ctx
 * @param {string|null|undefined} ctx.userGroupType
 * @param {string|null|undefined} ctx.userGroupId
 * @param {string|null|undefined} ctx.userId
 * @param {boolean|undefined} ctx.canAccessReports
 * @param {string|undefined|null} ctx.manager
 * @param {Array<{_id: string}>|undefined|null} ctx.associatePdvsData - `data` de `/group/chain-list` (filhos)
 * @returns {Array<object>}
 */
export function filterHomeReportsForMegaDash(reportsData, ctx) {
	const {userGroupType, userGroupId, userId, canAccessReports, manager, associatePdvsData} = ctx;

	const isGestorPdv = userGroupType === 'store' && manager === 'store';
	const canSeePdvDashboards = canAccessReports === true || isGestorPdv;

	if (!Array.isArray(reportsData)) {
		return [];
	}

	const included = [];
	for (const e of reportsData) {
		const chart = {...e};
		chart.link = `/chart/${chart._id}`;
		chart.label = chart.name;

		let groupTypeName;
		switch (chart.groupType) {
			case 'hub':
				groupTypeName = chart.groupType;
				chart.sort = 1;
				break;
			case 'group':
				groupTypeName = 'association';
				chart.sort = 2;
				break;
			case 'pdv':
				groupTypeName = 'store';
				chart.sort = 3;
				break;
			default:
				groupTypeName = chart.groupType;
				chart.sort = 4;
				break;
		}

		let hit = false;
		if (userGroupType === 'nimbus') {
			hit = true;
		} else if (canAccessReports === true && userGroupType === 'hub') {
			// Hub: todos os dashboards retornados pelo backend (tenant)
			hit = true;
		} else if (
			canSeePdvDashboards &&
			userGroupType === groupTypeName &&
			String(chart.groupId) === String(userGroupId)
		) {
			chart.bold = true;
			hit = true;
		} else if (
			canAccessReports === true &&
			userGroupType === 'association' &&
			groupTypeName === 'store' &&
			associatePdvsData &&
			associatePdvsData.some(pdv => String(pdv._id) === String(chart.groupId))
		) {
			hit = true;
		} else if ((chart.groupType === '' || chart.groupType === null) && String(chart.groupId) === String(userId)) {
			hit = true;
		}

		if (hit) {
			included.push(chart);
		}
	}

	return included.sort((a, b) => a.sort - b.sort);
}
